import { useMemo } from 'react';
import { useAuthContext } from './useAuthContext';

export const useCompanyCategory = () => {
  const { user } = useAuthContext();

  const typeBussinesFood = useMemo(
    () => ['bar', 'nightclub', 'restaurant', 'iceCreamShop', 'bakery'],
    []
  );

  const isFoodCompany = useMemo(
    () => typeBussinesFood.includes(user?.companySelected?.typeBusiness ?? ''),
    [typeBussinesFood, user?.companySelected?.typeBusiness]
  );

  return {
    isFoodCompany,
  };
};
